import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchMrdMonitoringReportsAllMRDs = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdMonitoringReportsAllMRDs',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      filter: 'AllMRDs',
    },
  });
  return axios.get(serviceURL, payload);
};
